/* eslint-disable react/button-has-type */
import React, { Component } from 'react';
import { Toast, Icon } from 'antd-mobile';
import copy from 'copy-to-clipboard';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import styles from './styles.module.less';
import {
  getImAppId, getImOpenId, getUserRank, shareQrCode, shareUrl,
} from '../../service/chat-service';
import tools from '../../utils/tools';
import homebackground from '../../public/images/fuzhilianjie.png';
import paihangbang from '../../public/images/paihangbang.png';
import yi from '../../public/images/1.png';
import er from '../../public/images/2.png';
import san from '../../public/images/3.png';

const homeImage = {
  backgroundSize: '100% 100%', // 记得这里100%
  // background: `url(${homeImage})`,
  // 或者下面这种也行
  backgroundImage: `url(${homebackground})`,
};
const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};
const defaultProps = {};

// 直播分享页
class index extends Component {
  constructor(props) {
    super(props);
    const windowHref = `?${decodeURIComponent(window.location.href).split('?')[1]}`;
    const id = new URLSearchParams(windowHref).get('id');
    const shareUserId = new URLSearchParams(windowHref).get('shareUserId');
    this.state = {
      id,
      shareUserId,
      dataList: [], // 排行
      qrCode: '', // 二维码
      codeLink: '', // 复制链接
    };
  }

  componentDidMount() {
    document.title = '分享';
    this.getLiveOpenId(); // 微信授权上线前打开
    // this.getUserRankLiveInfo();// 本地测试上线前关闭
    // this.shareQrCodes();// 本地测试上线前关闭
  }

  /**
   * 微信授权
   * @returns {Promise<void>}
   */
  getLiveOpenId = async () => {
    const windowHref = `?${decodeURIComponent(window.location.href).split('?')[1]}`;
    const WXCode = queryString.parse(windowHref).code;
    if (!WXCode) {
      localStorage.clear();
      try {
        const { code, data, message } = await getImAppId();
        if (process.env.REACT_APP_API_ENV === 'local') {
          // 本地测试时不走微信验证
          this.getUserRankLiveInfo('oQd0LwJcSPgP7eYwSy38bUdb793A');
        } else if (code === 10000) {
          window.location.href = tools.toWxth(data);
        } else {
          Toast.show(message || '获取微信 appId 失败');
        }
      } catch (e) {
        Toast.show('获取微信 appId 失败');
      }
    } else if (!localStorage.getItem('openId')) {
      try {
        const { code, data } = await getImOpenId(WXCode);
        if (code === 10000) {
          localStorage.setItem('openId', data.openid);
          this.getUserRankLiveInfo(data.openid);
          this.shareQrCodes(data.openid);
          this.getShareUrl(data.openid);
        }
      } catch (e) {
        Toast.show(e);
      }
    } else {
      this.getUserRankLiveInfo(localStorage.getItem('openId'));
      this.shareQrCodes(localStorage.getItem('openId'));
      this.getShareUrl(localStorage.getItem('openId'));
    }
  }

  /**
   * 获取详情
   * @param openId
   * @param getType
   */
  getUserRankLiveInfo = async (openId) => {
    const { id } = this.state;
    const params = {
      openId, id: Number(id), pageNum: 1, pageSize: 3,
    };
    // const params = {//本地联调
    //   openId: '11111',
    //   id: 647,
    //   pageNum: 1,
    //   pageSize: 3,
    // };
    try {
      const { data } = await getUserRank(params);
      this.setState({
        dataList: data.pageList,
      });
    } catch (e) {
      Toast.show('获取详情失败');
    }
  }

  // 分享二维码
  shareQrCodes = async () => {
    const { shareUserId, id } = this.state;
    const params = {
      id: Number(id),
      staffUserId: shareUserId,
      staffOpenId: localStorage.getItem('openId'),
    };
    try {
      const { data } = await shareQrCode(params);
      this.setState({
        qrCode: data,
      });
    } catch (e) {
      Toast.show('获取二维码失败');
    }
  }

  // 复制链接
  getShareUrl= async () => {
    const { shareUserId, id } = this.state;
    const params = {
      id: Number(id),
      staffUserId: shareUserId,
      staffOpenId: localStorage.getItem('openId'),
    };
    try {
      const { data } = await shareUrl(params);
      this.setState({
        codeLink: data,
      });
    } catch (e) {
      Toast.show('获取二维码失败');
    }
  }

  // 复制链接
  copys = () => {
    const { codeLink } = this.state;
    if (copy(codeLink)) {
      copy(codeLink);
      Toast.show('复制成功!');
    }
  }

  // 跳转到排行榜页面
  golink = () => {
    const { id } = this.state;
    const { history } = this.props;
    history.push(`/sharelist?id=${id}`);
  }

  ranking=() => {
    const { dataList } = this.state;
    return dataList.map((item, k) => (
      <div key={item.id} className={styles.paiheadUrl} style={{ borderColor: `${k === 0 ? '#FF6464' : '#FFBB00'}` }}>
        <img src={item.headUrl} alt="" />
        {k === 0 ? <i><img src={yi} alt="" /></i> : ''}
        {k === 1 ? <i><img src={er} alt="" /></i> : ''}
        {k === 2 ? <i><img src={san} alt="" /></i> : ''}
      </div>
    ));
  }

  render() {
    const { qrCode } = this.state;
    return (
      <div className={styles.body}>
        <div className={styles.f_content}>
          <div>
            <img src={qrCode} alt="" />
          </div>
          <div>长按识别二维码参与活动</div>
        </div>
        <div className={styles.f_rankingList}>
          <div>
            <img src={paihangbang} alt="" />
            <span>排行榜</span>
          </div>
          <div>
            {this.ranking()}
          </div>
          <div role="button" tabIndex={0} onClick={this.golink}>
            <Icon type="right" />
          </div>
        </div>
        <div
          className={styles.f_footer}
          style={homeImage}
        >
          点击复制链接，分享好友
          <div onClick={this.copys} role="button" tabIndex={0} className={styles.buttons}>复制链接</div>
        </div>
      </div>
    );
  }
}

index.propTypes = propTypes;
index.defaultProps = defaultProps;

export default index;
